import { render, staticRenderFns } from "./FollowAccount.vue?vue&type=template&id=43365ea4&scoped=true"
import script from "./FollowAccount.vue?vue&type=script&lang=js"
export * from "./FollowAccount.vue?vue&type=script&lang=js"
import style0 from "./FollowAccount.vue?vue&type=style&index=0&id=43365ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43365ea4",
  null
  
)

export default component.exports